/* tslint:disable */
/* eslint-disable */
/**
 * Zamna Ready To Fly API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.18
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * A record of mismatches to Zamna Signals for document applied
 * @export
 * @interface PaxCheckSignalsMismatches
 */
export interface PaxCheckSignalsMismatches {
    /**
     * 
     * @type {Array<string>}
     * @memberof PaxCheckSignalsMismatches
     */
    fields: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof PaxCheckSignalsMismatches
     */
    type: string;
}

/**
 * Check if a given object implements the PaxCheckSignalsMismatches interface.
 */
export function instanceOfPaxCheckSignalsMismatches(value: object): value is PaxCheckSignalsMismatches {
    if (!('fields' in value) || value['fields'] === undefined) return false;
    if (!('type' in value) || value['type'] === undefined) return false;
    return true;
}

export function PaxCheckSignalsMismatchesFromJSON(json: any): PaxCheckSignalsMismatches {
    return PaxCheckSignalsMismatchesFromJSONTyped(json, false);
}

export function PaxCheckSignalsMismatchesFromJSONTyped(json: any, ignoreDiscriminator: boolean): PaxCheckSignalsMismatches {
    if (json == null) {
        return json;
    }
    return {
        
        'fields': json['fields'],
        'type': json['type'],
    };
}

export function PaxCheckSignalsMismatchesToJSON(json: any): PaxCheckSignalsMismatches {
    return PaxCheckSignalsMismatchesToJSONTyped(json, false);
}

export function PaxCheckSignalsMismatchesToJSONTyped(value?: PaxCheckSignalsMismatches | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'fields': value['fields'],
        'type': value['type'],
    };
}

